import React from 'react'

export default function HeroMessageAr() {
  return (
    <p className="px-8 text-center text-3xl font-bold !leading-[2.5] text-white sm:px-8 md:text-right md:text-5xl md:!leading-[2] lg:p-0">
      أول منصة معلوماتية وتفاعلية
      <br />
      <span className="text-secondary-600 text-5xl font-black md:text-6xl"> لمعادن </span>
      <span className="text-primary-600 text-5xl font-black md:text-6xl"> المستقبل </span>
      <br />
      في المنطقة العربية
    </p>
  )
}
